import { useRef as c, useEffect as l, useMemo as f } from "react";
function* a(n, t) {
  if (t < 1)
    throw new Error("chunkSize expected to be grater than 0");
  for (let e = 0; e < n.length; e += t)
    yield n.slice(e, e + t);
}
const b = (n, t) => {
  const [e] = u(n, t);
  return e;
}, u = (n, t) => {
  let e;
  return [
    (...r) => {
      window.clearTimeout(e), e = window.setTimeout(() => n(...r), t);
    },
    () => {
      window.clearTimeout(e);
    }
  ];
}, w = (n, t, e = []) => {
  const r = c(!0);
  l(() => (r.current = !0, () => {
    r.current = !1;
  }));
  const o = c(null);
  return f(() => {
    o.current !== null && o.current();
    const [d, i] = u((...s) => {
      r.current && n(...s);
    }, t);
    return o.current = i, d;
  }, [t, n, ...e]);
}, h = (n, t) => {
  const e = document.createElement("a");
  try {
    e.href = URL.createObjectURL(n), e.style.display = "none", e.download = t, document.body.appendChild(e), e.click();
  } finally {
    document.body.removeChild(e), URL.revokeObjectURL(e.href);
  }
};
export {
  b as debounce,
  u as debounceWithAbort,
  a as makeChunks,
  h as saveFileAs,
  w as useDebounce
};
//# sourceMappingURL=index.js.map
